<template>
  <div class="formdata building">
    <div class="header-container">
    <h3 id="power_consumers_question">Welche größeren Stromverbraucher nutzen Sie?</h3>
    <span class="center">Mehrfachauswahl möglich</span>
</div>
    <CustomCheckboxGroup
        :options="powerConsumers"
        v-model="selectedPowerConsumer"
        aria-labelledby="power_consumers_question"
    >
      <template #option="{ option }">
        <label :for="'power_consumer_' + option.value">
          <img v-if="option.image" :src="option.image" alt="" aria-hidden="true" />
          <p>{{ option.name }}</p>
        </label>
      </template>
    </CustomCheckboxGroup>

    <button class="button button_yellow right" v-if="selectedPowerConsumer.length > 0" @click="submit">Weiter</button>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useWorkflowStore } from '../../stores/workflow.js';
import { powerConsumers, powerConsumersApi } from '@/data/powerConsumers';
import CustomCheckboxGroup from "@/components/CustomCheckboxGroup.vue";

const workflowStore = useWorkflowStore();

// Hilfsfunktion: Findet das komplette Datenobjekt basierend auf dem Wert-String
const getFullPowerConsumer = (selectedValue) => {
  return powerConsumers.find(bt => bt.value === selectedValue);
};

// ... Die gesamte computed und submit Logik bleibt UNVERÄNDERT ...

/**
 * Computed Property für v-model.
 * Stellt die bidirektionale Bindung zwischen dem UI (Checkboxen) und dem Workflow Store her.
 */
const selectedPowerConsumer = computed({
  get() {
    // Holt das Array der ausgewählten Werte (Strings) aus dem Store.
    const consumers = workflowStore.workflowContext.formData.building?.power_consumers;
    return consumers || [];
  },
  set(newValues) {
    // 1. Erstellt das Array der API-Werte (apiValues)
    const apiValuesArray = newValues
        .map(value => {
          const fullConsumer = getFullPowerConsumer(value);
          return fullConsumer ? fullConsumer.api : null;
        })
        .filter(data => data !== null);

    // 2. Sendet das Event mit der gewünschten Struktur an den Store
    workflowStore.sendWorkflowEvent({
      type: 'UPDATE_SELECTED_POWER_CONSUMERS',
      data: {
        apiDefinition: powerConsumersApi,
        apiValues: apiValuesArray,
        selected: newValues,
      },
    });
  }
});

/**
 * Verarbeitet den Klick auf den "Weiter"-Button und sendet das NEXT-Event.
 */
const submit = () => {
  if (selectedPowerConsumer.value && selectedPowerConsumer.value.length > 0) {
    const apiValuesArray = selectedPowerConsumer.value
        .map(value => {
          const fullConsumer = getFullPowerConsumer(value);
          return fullConsumer ? fullConsumer.api : null;
        })
        .filter(data => data !== null);

    workflowStore.sendWorkflowEvent({
      type: 'NEXT',
      data: {
        apiDefinition: powerConsumersApi,
        apiValues: apiValuesArray,
        selected: selectedPowerConsumer.value,
      },
    });
  }
};
</script>

<style scoped>
#app-ves-clickstream .center{
  display: block;
  text-align: center;
  margin-bottom: 45px;
}

#app-ves-clickstream .formdata h3 {
  /* Setzt den unteren Margin auf einen kleineren Wert (oder 0),
     damit das Span näher an die Überschrift rückt. */
  margin-bottom: 3px;
}
</style>